import type { PaymentIntent } from "@stripe/stripe-js";
import { parseAsString, parseAsStringLiteral, useQueryState } from "nuqs";
import { useCallback, useMemo } from "react";

const PAYMENT_INTENT_STATUS: PaymentIntent["status"][] = [
    "requires_action",
    "requires_confirmation",
    "requires_payment_method",
    "requires_capture",
    "processing",
    "succeeded",
    "canceled",
] as const;

export function useStripePaymentRedirectResult() {
    const [paymentIntent, setPaymentIntent] = useQueryState("payment_intent", parseAsString.withDefault(""));
    const [paymentIntentClientSecret, setPaymentIntentClientSecret] = useQueryState(
        "payment_intent_client_secret",
        parseAsString.withDefault(""),
    );
    const [redirectStatus, setRedirectStatus] = useQueryState(
        "redirect_status",
        parseAsStringLiteral(PAYMENT_INTENT_STATUS),
    );

    const clearStripePaymentRedirectParams = useCallback(async () => {
        await setPaymentIntent(null);
        await setPaymentIntentClientSecret(null);
        await setRedirectStatus(null);
    }, [setPaymentIntent, setPaymentIntentClientSecret, setRedirectStatus]);

    const result = useMemo(() => {
        if (!paymentIntent || !paymentIntentClientSecret || !redirectStatus) {
            return null;
        }
        return {
            paymentIntent,
            paymentIntentClientSecret,
            redirectStatus,
        };
    }, [paymentIntent, paymentIntentClientSecret, redirectStatus]);

    return {
        redirectResult: result,
        clearStripePaymentRedirectParams,
    };
}
